var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobManagementNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "95 645 30 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M97.07,664.46h25.82c.34,0,.59-.28.59-.59v-16.49c0-.31-.25-.59-.59-.59h-25.82c-.34,0-.59.28-.59.59v16.49c0,.31.25.59.59.59ZM109.92,662.1h-10.51c-.34,0-.59-.25-.59-.59,0-.31.25-.59.59-.59h10.51c.31,0,.59.28.59.59,0,.34-.28.59-.59.59ZM99.41,657.39h7.25c.31,0,.59.25.59.59,0,.31-.28.59-.59.59h-7.25c-.34,0-.59-.28-.59-.59,0-.34.25-.59.59-.59ZM98.82,654.46c0-.34.25-.59.59-.59h3.52c.31,0,.59.25.59.59,0,.31-.28.59-.59.59h-3.52c-.34,0-.59-.28-.59-.59ZM121.13,661.6c0,.24-.1.46-.26.61-.15.17-.38.26-.61.26h-6.16c-.24,0-.46-.09-.61-.26-.17-.15-.26-.37-.26-.61v-.47c0-1.09.45-2.07,1.16-2.78.47-.49,1.09-.84,1.76-1.02-.24-.13-.49-.28-.68-.49-.43-.43-.7-1.03-.7-1.69s.27-1.26.7-1.7c.43-.43,1.03-.7,1.7-.7s1.25.27,1.69.7c.43.43.7,1.03.7,1.7s-.27,1.25-.7,1.69c-.19.2-.42.36-.68.49.68.18,1.29.54,1.78,1.02.72.72,1.16,1.7,1.16,2.78v.47ZM97.98,650.34h23.88c.31,0,.59.25.59.59,0,.31-.28.56-.59.56h-23.88c-.31,0-.59-.25-.59-.56,0-.34.28-.59.59-.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobManagementNav);
export default __webpack_public_path__ + "static/media/job-management-nav.58a24cc00ca36da9260f8c3d11014dcf.svg";
export { ForwardRef as ReactComponent };